import * as React from "react";
import { List, Typography } from "@mui/material";

export function PostTags(props: { parentIndex: number; tags: string[] }) {
  return (
    <List sx={{ display: "flex", paddingLeft: "16px" }}>
      {props.tags.map((tag: string, index: number) => {
        return (
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: "bold",
              lineHeight: "1",
              marginRight: ".3rem",
              color: "accent.main",
              backgroundColor: "background.paper",
              padding: "2px 6px",
              borderRadius: "4px",
              border: "1px solid",
              borderColor: "accent.main",
            }}
            key={index}
          >
            {tag}
          </Typography>
        );
      })}
    </List>
  );
}
